(function(factory) {
  if (typeof define === 'function' && define.amd) {
    define(['jquery'], factory);
  } else if (typeof module === 'object' && module.exports) {
    module.exports = factory(require('jquery'));
  } else {
    // Browser globals
    factory(jQuery);
  }
}(function($) {
  $.fn.initial = function(options) {
    return this.each(function() {

      var e = $(this);
      var settings = $.extend({
        // Default settings
        name: 'Name',
        seed: 0,
        charCount: 1,
        wordCount: 2,
        textColor: '#ffffff',
        height: 100,
        width: 100,
        fontSize: 60,
        fontWeight: 400,
        fontFamily: 'HelveticaNeue-Light,Helvetica Neue Light,Helvetica Neue,Helvetica, Arial,Lucida Grande, sans-serif',
        radius: 0,
        src: null,
		backgroundColor: '#000000'
      }, options);

      // overriding from data attributes
      settings = $.extend(settings, e.data());

      if (settings.src) {
        e.css({
          'width': settings.width + 'px',
          'height': settings.height + 'px',
          'border-radius': settings.radius + 'px',
          '-moz-border-radius': settings.radius + 'px'
        }).attr("src", settings.src);

        return;
      }

      settings.name = settings.name || 'DaMaVaNd';

      // making the text object
      var c = settings.name.split(" ", settings.wordCount).map(function(str) {
        return str.substr(0, settings.charCount).toUpperCase();
      }).join("");
      var cobj = $('<text text-anchor="middle"></text>').attr({
        'y': '50%',
        'x': '50%',
        'dy': '0.35em',
        'pointer-events': 'auto',
        'fill': settings.textColor,
        'font-family': settings.fontFamily
      }).html(c).css({
        'font-weight': settings.fontWeight,
        'font-size': settings.fontSize + 'px'
      });

      var svg = $('<svg></svg>').attr({
        'xmlns': 'http://www.w3.org/2000/svg',
        'pointer-events': 'none',
        'width': settings.width,
        'height': settings.height
      }).css({
        'background-color': settings.backgroundColor,
        'width': settings.width + 'px',
        'height': settings.height + 'px',
        'border-radius': settings.radius + 'px',
        '-moz-border-radius': settings.radius + 'px'
      });

      svg.append(cobj);
      // svg.append(group);
      var svgHtml = window.btoa(unescape(encodeURIComponent($('<div>').append(svg.clone()).html())));

      e.attr("src", 'data:image/svg+xml;base64,' + svgHtml);
    });
  };
}));
